var _style, _polygon, _polygon2, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBgLeft = function SvgBgLeft(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 892 893",
    style: {
      enableBackground: "new 0 0 892 893"
    },
    xmlSpace: "preserve",
    width: 892,
    height: 893,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.BGLeft_st0{ ", "\n\t\tfill:#f5fbfd;\n\t}\n\t.BGLeft_st1{ ", "\n\t\tfill:url(#SVGID_1_);\n\t}\n\t.BGLeft_st2{", "\n\t\tfill:#EDF8FA;\n\t}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "BGLeft_st0",
    points: "390.4,0.6 195.9,195.1 1.5,0.6 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 446.024,
    y1: 6,
    x2: 446.024,
    y2: 890.0814,
    gradientTransform: "matrix(-1 0 0 1 892.0481 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5FBFD",
      stopOpacity: 0
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "BGLeft_st1",
    points: "890.5,889.7 1.5,889.7 1.5,389.5 195.9,195.1 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "BGLeft_st2",
    points: "195.9,195.1 1.5,389.5 1.5,0.6 "
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBgLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BGLeft.ab199c4db8b5d603a4f583fa137d7e44.svg";